import { NgModule } from '@angular/core';

import { BarsTooltipDirective } from './bars-tooltip.directive';

@NgModule({
    declarations: [BarsTooltipDirective],
    exports: [BarsTooltipDirective],
})
export class DirectivesModule {}
